import styled from 'styled-components';

import { Grid2 as Grid } from '@mui/material';
import { Box } from '@mui/system';

import CustomInput from 'components/CustomInput';

export const ModalBox = styled(Box)`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 24;
  border: none;
  text-align: left;
  outline: none;
  z-index: 1300;
  max-width: 300px;
`;

export const ModalHeader = styled.div`
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: 10px 16px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const ModalContent = styled.div`
  padding: 30px 30px 20px 30px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const ModalActionButtons = styled(Grid)`
  padding: 15px;
  margin-top: 0;
`;

export const InputLineNumber = styled(CustomInput)`
  margin-top: 0;
`;
